import React, { useState } from 'react';
import { usePublisherAuth } from '../contexts/PublisherAuthContext';
import { Link } from 'react-router-dom';

const PublisherLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = usePublisherAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);
      // The login function will handle navigation
    } catch (err) {
      setError(err.message || 'Failed to log in. Please check your credentials.');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-8 bg-wp-surface rounded-xl border border-wp-border">
      <h2 className="text-2xl font-bold text-center text-white mb-2">Publisher Login</h2>
      <p className="text-center text-wp-muted mb-6">Access your publisher dashboard.</p>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="email" className="block text-wp-muted text-sm font-medium mb-2">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full bg-wp-bg text-white placeholder-wp-muted rounded-lg px-3 py-2 border border-wp-border focus:outline-none focus:ring-2 focus:ring-wp-accent"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="password" className="block text-wp-muted text-sm font-medium mb-2">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full bg-wp-bg text-white placeholder-wp-muted rounded-lg px-3 py-2 border border-wp-border focus:outline-none focus:ring-2 focus:ring-wp-accent"
          />
        </div>
        {error && <p className="text-wp-danger text-sm mb-4">{error}</p>}
        <button
          type="submit"
          className="w-full bg-wp-accent hover:opacity-90 text-wp-bg font-bold py-2.5 px-4 rounded-lg transition-opacity"
        >
          Log In
        </button>
      </form>
      <p className="text-center text-sm text-wp-muted mt-4">
        Don&apos;t have a publisher account?{' '}
        <Link to="/publisher/register" className="font-semibold text-wp-accent hover:opacity-80">Register here</Link>.
      </p>
    </div>
  );
};

export default PublisherLoginPage;
